import { render, staticRenderFns } from "./LanguageChanger.vue?vue&type=template&id=08813776&"
import script from "./LanguageChanger.vue?vue&type=script&lang=js&"
export * from "./LanguageChanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports